import { createApi } from '@reduxjs/toolkit/query/react';
import { DocumentTypesLookup } from 'model';
import { baseQueryWithReauth } from './baseQueryWithReauth';

export const BaseApi = createApi({
	tagTypes: Object.values(DocumentTypesLookup),
	reducerPath: 'BaseApi',
	baseQuery: baseQueryWithReauth({
		baseUrl: '/api/'
	}),
	refetchOnMountOrArgChange: true,
	endpoints: () => ({})
});
